declare global {
  interface Window {
    hj?: (...args: any[]) => void;
  }
}

export const useHotjar = () => {
  const event = (name: string) => {
    if (name) {
      window.hj?.('event', name);
    }
  };

  const identify = (userId: string, attrs?: Record<string, any>) => {
    if (userId) {
      window.hj?.('identify', userId, attrs || {});
    }
  };

  const fetchAnalyticsData = async (email: string) => {
    try {
      if (!email) {
        return null;
      }

      const response = await fetch(`/backend/hj/user-info?email=${encodeURIComponent(email)}`);
      const data = await response.json();

      return data as {
        userId: string | undefined;
        stag: string | undefined;
        registrationDate: string | undefined;
        lastDepositDate: string | undefined;
        userGroup: string | undefined;
        depositsCount: string | undefined;
        totalDepositsCount: string | undefined;
        lastLoginCountry: string | undefined;
      };
    } catch (e) {
      console.error('Failed to fetch user analytics', e);
      return null;
    }
  };

  return { event, identify, fetchAnalyticsData };
};
